import { render, staticRenderFns } from "./GroupIcon.vue?vue&type=template&id=0aa5ee9e&"
import script from "./GroupIcon.vue?vue&type=script&lang=js&"
export * from "./GroupIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports